
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputRight as ObiInputRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-right.js';
 
 
 

 
 export const ObiInputRight = createComponent({
   react: React,
   tagName: 'obi-input-right',
   elementClass: ObiInputRightElement,
   events: {
     
   }
  });
 
 